module.exports = __webpack_public_path__ + "c36b70091a4bde2019a6b90fa9cfc0da.png";